// Turns a literal `<br>` in an answer into a real line break, and nothing else.
//
// Models write `<br>` inside Markdown table cells, where Markdown has no line-break syntax of its
// own. The chat renders Markdown without raw HTML, so that tag reached the person as the literal
// text "<br>". Raw HTML stays off on purpose: answers carry profile text, and letting HTML through
// would let a prompt-injected profile field put markup on the page. This converts exactly one tag,
// in its three spellings, into Markdown's own `break` node; every other tag is still escaped.

interface MdNode {
  type: string;
  value?: string;
  children?: MdNode[];
}

const BR = /^<br\s*\/?>$/i;

function walk(node: MdNode): void {
  if (!node.children) return;
  node.children = node.children.map((child) =>
    child.type === "html" && BR.test((child.value ?? "").trim()) ? { type: "break" } : child,
  );
  for (const child of node.children) walk(child);
}

/** remark plugin: `<br>` / `<br/>` / `<br />` become line breaks, inside table cells included. */
export function remarkHtmlBreaks() {
  return (tree: MdNode) => walk(tree);
}
